// extracted by mini-css-extract-plugin
module.exports = {"approach":"flowChart_approach__GrjJy","subheadline":"flowChart_subheadline__JBPhH","steps":"flowChart_steps__kQ5hM","card":"flowChart_card__dN0o8"};